<div class="p-3 inner-content">
  <lyceo-ui-modal-header
    class="mb-2"
    [text]="header()"
    (closeModal)="close()"
    data-testid="alert-modal-header"
  />
  <p class="mb-3" data-testid="alert-modal-message">{{ message() }}</p>
  <div class="buttons">
    @if (cancelButton()) {
      <button
        class="mr-2"
        lyceoButton
        type="button"
        [fill]="ButtonFill.CLEAR"
        (click)="close()"
        data-testid="alert-modal-cancel-button"
      >
        {{ cancelButton() }}
      </button>
    }
    <button
      lyceoButton
      type="button"
      [fill]="ButtonFill.CLEAR"
      (click)="confirm()"
      data-testid="alert-modal-confirm-button"
    >
      {{ confirmButton() }}
    </button>
  </div>
</div>
